module.exports = __webpack_public_path__ + "img/sgs-logo.bd3b1b2f.png";